module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/layout/layout-grid-d5ee87fd04050da7cb9a7a521d5d6998.svg";